/* istanbul ignore file */
import Disapproval from './Disapproval';

export default Disapproval;
